import { Box, FormHelperText } from '@mui/material';

import { Text } from 'common';

import { ProducedType } from '../../../types';
import { type BlockConfigProps } from '../../types';

function BlockContent() {
  return (
    <Box>
      <Text>No configuration required</Text>
      <FormHelperText>Extract patient data from Notable databases.</FormHelperText>
    </Box>
  );
}

const documentationMarkdown = `
# Get Patient

Retrieve the full patient record from the Notable database for the entity that started the flow

This block deliberately does not let you search for a patient. As a security and data-integrity protection practice
a flow acts against one and only one entity. This blocks manages retrieving the _right_ patient based on how the flow was started,
and protections in the Notable Flow Builder product ensure that all patient data retrieved is for this patient
`;

export const getPatientConfig: BlockConfigProps = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'patient',
  defaultConfig: {
    returnType: ProducedType.Patient,
  },
  configFields: undefined,
  BlockContent,
  documentationMarkdown,
};
